import { Component, OnInit } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { ReportesCobranzaService } from '../../../services/reportes/reportes-cobranzas.service';
import { ReportsHelperService } from '../../../services/tools/reports-helpers.service';
import { CreditosService } from "../../../services/creditos.service";
import { SucursalesService } from '../../../services/sucursales.service';

@Component({
    selector: 'app-reporte-cobranza-general',
    templateUrl: './reporte-cobranza-general.component.html'
  })

export class ReporteCobranzaGeneralComponent implements OnInit {

    public reportData: any [] = [];
    public totales: any = {};
    public tipoCreditoSelected: any = '';
    public tiposCreditos: any[] = [];
    //Filtros
    public fechaFin: string = null;
    //Helpers
    public isLoading: boolean = true;
    public isItemsArrayEmpty: boolean = null;

    public sucursales: any[] = [];
    public sucursal: any = {id:null};
    public sucursalPorDefecto: string = "";

    constructor(
        private helperService: HelpersService,
        private reportesService: ReportesCobranzaService,
        public helper: ReportsHelperService,
        private creditosService: CreditosService,
        private sucursalesService : SucursalesService
    ){

    }

    public ngOnInit() {
        this.setupDefaultState();
    }

    public onChangeTipoCredito(){
        this.updateReporte();
    }

    private setupDefaultState() {
        this.fechaFin = this.helper.getDefaultCobranzaDate();
        this.getTiposCreditos();
        this.getSucursales();
    }

    private getSucursales(){
        this.isLoading = true;
        this.sucursalesService.get().subscribe(
          (response)=>
          {
            const jsonResult = response.json();
            if(jsonResult.content){
              this.sucursales = jsonResult.content.data;
              if (this.sucursales.length>1){
                this.sucursalPorDefecto = "Seleccione";
              } else if(this.sucursales.length>0){
                this.sucursal =  this.sucursales[0];
              }
              this.updateReporte();
              this.isLoading = false; 
            }
            
          }, error =>
          {
            // se resuelve error 403 y 500
            this.isLoading = false;
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }
    
    sucursalChanged(sucursal){
        if(sucursal){
        this.sucursal = sucursal;
        this.updateReporte();
        }
    }

    public updateReporte(){

        let filters = {
            fechaFin: this.fechaFin,
            tipoCredito: this.tipoCreditoSelected,
            sucursal : this.sucursal.id
        }

        //Mostrar el ajax loading
        this.isLoading = true;

        this.reportesService.getReporteGeneral(filters).subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                let items = [];
                let totales = {};
                if(jsonResult.content ){
                    if(jsonResult.content.items){
                        items = jsonResult.content.items;
                    }
                    if(jsonResult.content.totales){
                        totales = jsonResult.content.totales;
                    }
                }

                this.reportData = items;
                this.totales = totales;
                this.isLoading = false;
                this.isItemsArrayEmpty = this.reportData.length == 0;
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    public print(){
        //Imprimir pantalla
        window.print();
    }

    public descargar() {

        let filters = {
            fechaFin: this.fechaFin,
            tipoCredito: this.tipoCreditoSelected
        }

        this.reportesService.exportReporteGeneralToExcel(filters).subscribe(
            (response)=>
            {
            const fileUrl = window.URL.createObjectURL(response.blob());
            //Muestra el archivo en una nueva ventana
            window.open(fileUrl);
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    private getTiposCreditos(){
        this.creditosService.getTiposCreditos().subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                if(jsonResult.content){
                    this.tiposCreditos = jsonResult.content;
                }
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);

                if(error.status == 400) {
                    this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/reportes/cobranza/general/reporte-cobranza-general.component.ts